import React from 'react';
import { useTranslation } from 'react-i18next';

// Import styles
import { LoginTemplateHeadline, LoginTemplateHeader, LoginTemplateDescription, LoginTemplateGrid } from './styles';

// Import utilities
import { useProtectedPage } from 'components/utilities';

type Props = {
	children: React.ReactNode;
	type: 'login' | 'register';
};

export const LoginTemplate = ({ children, type }: Props) => {
	const { t } = useTranslation('login');
	const title = useProtectedPage((state) => state.title);

	return (
		<LoginTemplateGrid>
			<LoginTemplateHeadline data-aos="fade-right">
				<LoginTemplateHeader>{title ? `${t(type)}, ${title}` : t('default_header')}</LoginTemplateHeader>
				{!title && <LoginTemplateDescription>{t(`default_description_${type}`)}</LoginTemplateDescription>}
			</LoginTemplateHeadline>
			<div data-aos="zoom-in-up">{children}</div>
		</LoginTemplateGrid>
	);
};
